import axios from 'axios'
import qs from 'qs';
import {
    message
} from 'antd';
import {API_CONFIG} from './config'

var userBase = API_CONFIG.userBase,
    base = API_CONFIG.base,
    weixinBase = API_CONFIG.weixinBase,
    yun_url=API_CONFIG.yun_url;

//请求拦截
// axios.defaults.withCredentials = true;
axios.interceptors.request.use(
    config => {

        return config;

    },
    function (error) {

        return Promise.reject(error);

    }
)
//响应拦截
axios.interceptors.response.use(function (response) {
    if (response.data.code === 400) {

        if (document.domain === 'cloud.colourlife.com') {
            window.location.href = 'https://cloud-backyard.colourlife.com/#/';

        } else if (document.domain === 'cloudbeta.colourlife.com') {

            window.location.href = 'https://cloud-backyardbeta.colourlife.com/#/';

        } else {
            //window.location.href = 'https://cloud-backyardtest.colourlife.com/#/'
        }

        localStorage.clear();

        message.error(response.data.message);

    }

    if (response.data.code !== 0 && response.data.code !== 5017 && response.data.code!== 5018) {

        message.error(response.data.message);

    }else if(response.data.code===5013){
        
       // window.history.go(0);
    }

    return response;

}, function (error) {
    console.log(error)
    //    message.error(error);
    // Do something with response error  
    return Promise.reject(error)

})
export default {
    yun_url,
    base,
    weixinBase,
    //1, 顶部产品栏
    get_top_product: params => {
        return axios.get(`${userBase}/home/top/products`, {
            params: params
        }).then(res => res.data)
    },
    //2， 顶部客户案例  /home/top/customerCase/home/top/customerCase
    get_top_customerCase: params => {
        return axios.get(`${userBase}/home/top/customerCase`, {
            params: params
        }).then(res => res.data)
    },
    //3,顶部开放平台 /home/top/openPlatform
    get_top_openPlatform: params => {
        return axios.get(`${userBase}/home/top/openPlatform`, {
            params: params
        }).then(res => res.data)
    },
    //4,首页滚动banner
    get_home_banner: params => {
        return axios.get(`${userBase}/home/banners`, {
            params: params
        }).then(res => res.data)
    },
    //5，首页解决方案 /home/solution
    get_home_solution: params => {
        return axios.get(`${userBase}/home/solutions`, {
            params: params
        }).then(res => res.data)
    },
    //6，首页 核心产品 /home/coreProducts
    get_coreProducts: params => {
        return axios.get(`${userBase}/home/coreProducts`, {
            params: params
        }).then(res => res.data)
    },
    //7，首页合作伙伴 /home/cooperativePartner
    get_cooperativePartner: params => {
        return axios.get(`${userBase}/home/partners`, {
            params: params
        }).then(res => res.data)
    },
    //8，下载链接 /home/downloadLink
    get_downloadLink: params => {
        return axios.get(`${userBase}/home/downloadLinks`, {
            params: params
        }).then(res => res.data)
    },



    /**
     * 注册登录模块
     * 
     */
    //1.注册发送验证码
    sms_send_code: params => {
        return axios.post(`${userBase}/sms/sendCode`, qs.stringify(params)).then(res => res.data)
    },
    //2.验证码验证查询否有团队及团队名称 10.验证码登录
    check_has_group: params => {
        return axios.get(`${userBase}/check/account`, {params}).then(res => res.data)
    },
    //3.注册账号
    account_register: params => {
        return axios.post(`${userBase}/account/register`, qs.stringify(params)).then(res => res.data)
    },
    //4.注册团队
    register_group: params => {
        return axios.post(`${userBase}/corp/register`, qs.stringify(params)).then(res => res.data)
    },
    //5.图形验证码
    get_sso_captcha: params => {
        return axios.get(`${userBase}/sso/captcha`, {
            params: params
        }).then(res => res.data)
    },
    //6.账号密码登录
    sso_account_login: params => {
        return axios.post(`${userBase}/sso/account/login`, qs.stringify(params)).then(res => res.data)
    },
    //7.判断企业是否设置管理密码
    group_has_psw: params => {
        return axios.post(`${userBase}/team/passwordCheck`, qs.stringify(params)).then(res => res.data)
    },
    //8.设置企业管理密码
    setting_group_psw: params => {
        return axios.post(`${userBase}/team/passwordSet`, qs.stringify(params)).then(res => res.data)
    },
    //9.企业管理密码登录
    team_login: params => {
        return axios.post(`${userBase}/team/login`, qs.stringify(params)).then(res => res.data)
    },
    //10.验证码登录

    //11.获取二维码
    get_qr_code: params => {
        return axios.get(`${userBase}/sso/qrcode`, {
            params: params
        }).then(res => res.data)
    },
    //12.二维码登录
    sso_qr_code_login: params => {
        return axios.get(`${userBase}/sso/qrcode/token`, {
            params: params
        }).then(res => res.data)
    },
    //13、获取用户基本信息
    get_user_info: params => {
        return axios.get(`${userBase}/sso/qrcode/userinfo`, {
            params: params
        }).then(res => res.data)
    },
    //查询用户拥有的团队信息
    get_account_corps: params => {
        return axios.get(`${userBase}/account/corps`, {
            params: params
        }).then(res => res.data)
    },
    //登录指定团队后台
    get_company_login: params => {
        return axios.get(`${userBase}/company/login`, {params}).then(res => res.data)
    },
    //查询用户加入的团队
    get_join_query: params => {
        return axios.get(`${userBase}/corps/join/query`, {
            params: params
        }).then(res => res.data)
    },
    //登录完成注册团队
    create_group: params => {
        return axios.post(`${userBase}/corp/create`, qs.stringify(params)).then(res => res.data)
    },
    //岗位列表
    get_post_list: params => {
        return axios.get(`${userBase}/consultations/jobs`, {
            params: params
        }).then(res => res.data)
    },
    //公司规模
    get_c_scales_list:params=>{
        return axios.get(`${userBase}/consultations/corpScales`, {
            params: params
        }).then(res => res.data)
    },
    //图片验证码
    post_photo_sms: params => {
        return axios.post(`${userBase}/captchas`, qs.stringify(params)).then(res => res.data)
    },
    //提交咨询
    sub_consultations: params => {
        return axios.post(`${userBase}/consultations/create`, qs.stringify(params)).then(res => res.data)
    },
    // 切换企业，用当前企业token查询企业
    queryCompany: params => {
        return axios.get(`${userBase}/console/account/corps`, {
            params: params
        }).then(res => res.data)
    },
    
    // 获取企业token
    queryCompanyToken: params => {
        return axios.get(`${userBase}/console/company/login`, {
            params: params
        }).then(res => res.data)
    },

    // 企业微信登录
    weworkLogin: params => {
        return axios.post(`${userBase}/wework/login`, qs.stringify(params)).then(res => res.data)
    },

    // 设置企业相关secret
    setSecret: params => {
        return axios.post(`${weixinBase}/oauth/setSecret`, qs.stringify(params)).then(res => res.data)
    },

}


// WEBPACK FOOTER //
// ./src/api/api.js